import Location from '@/models/location';

/**
 * Determines the slot type (eat, stay, do, flight) based on location category
 * 
 * Maps Google Places categories to our slot types:
 * - Food-related categories → 'eat'
 * - Lodging categories → 'stay'
 * - Tourist attractions, parks, museums → 'do'
 * - Transportation (airports, transit) → 'flight'
 * - Default → 'do'
 * 
 * @param location - Location object with category_name
 * @returns Slot type string ('eat', 'stay', 'do', or 'flight')
 */
export const determineSlotType = (location: Location): string => {
    const category = location.category_name?.toLowerCase() || '';
    
    // Food-related categories
    if (
        category.includes('restaurant') ||
        category.includes('cafe') ||
        category.includes('food') ||
        category.includes('bakery') ||
        category.includes('bar') ||
        category.includes('meal') ||
        category.includes('dining')
    ) {
        return 'eat';
    }
    
    // Lodging categories
    if (
        category.includes('lodging') ||
        category.includes('hotel') ||
        category.includes('motel') ||
        category.includes('accommodation') ||
        category.includes('resort')
    ) {
        return 'stay';
    }
    
    // Transportation categories
    if (
        category.includes('airport') ||
        category.includes('transit') ||
        category.includes('train_station') ||
        category.includes('bus_station') ||
        category.includes('subway_station')
    ) {
        return 'flight';
    }
    
    // Tourist attractions, parks, museums, etc. (default for 'do')
    return 'do';
};

